/// Port of mobile/lib/game/game_event.dart. Dart uses a broadcast
/// StreamController; the web equivalent is a listener set.

export type GameEvent =
  | 'gameStarted'
  | 'gamePaused'
  | 'gameResumed'
  | 'gameOver'
  | 'returnedHome'
  | 'dinoCollision'
  | 'scoreUpdated';

export type GameEventListener = (event: GameEvent) => void;

export class GameEventEmitter {
  private listeners = new Set<GameEventListener>();

  listen(listener: GameEventListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(event: GameEvent): void {
    for (const listener of [...this.listeners]) {
      listener(event);
    }
  }

  close(): void {
    this.listeners.clear();
  }
}
